import { render, staticRenderFns } from "./StockMateriaPrimeraPerMagatzemList.vue?vue&type=template&id=30ca3b2e&scoped=true"
import script from "./StockMateriaPrimeraPerMagatzemList.vue?vue&type=script&lang=js"
export * from "./StockMateriaPrimeraPerMagatzemList.vue?vue&type=script&lang=js"
import style0 from "./StockMateriaPrimeraPerMagatzemList.vue?vue&type=style&index=0&id=30ca3b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ca3b2e",
  null
  
)

export default component.exports